import { ContextWrapper } from '@common/contexts/ContextWrapper';
import { RouteObject } from 'react-router';

export const RouteContext = new ContextWrapper<RouteObject[]>();
RouteContext.set([]);
